<span [class.count--error]="currentCount > maxCount">{{ currentCount }}</span
><span>/{{ maxCount }}</span>
